import Gzh from '../views/Data/Gzh';
import Lists from '../views/Data/Lists';
import WxList from '../views/Data/WxList';
import YcNumber from '../views/Data/YcNumber';
import Bigdata from '../views/Data/BigData';

let Data = [
  {
    path: 'Wechat',
    name: '微信',
    redirect: '/Main/Data/Wechat/Wx'
  },
  {
    path: 'Wechat/Wx',
    name: '微信最新文章',
    component: Lists
  },
  {
    path: 'Wechat/WxList',
    name: '数据文章列表',
    component: WxList
  },
  {
    path: 'Wechat/Gzh',
    name: '公众号列表',
    component: Gzh
  },
  {
    path: 'YcNumber',
    name: '融媒体号',
    component: YcNumber
  },
  {
    path: 'Bigdata',
    name: '互联网数据',
    component: Bigdata
  }
];
export default Data;
